import React, { useContext, useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import HomeIcon from "@material-ui/icons/Home";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import StoreIcon from "@material-ui/icons/Store";
import InboxIcon from "@material-ui/icons/Inbox";
import BarChartIcon from "@material-ui/icons/BarChart";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import ListIcon from "@material-ui/icons/List";
import AssignmentIcon from "@material-ui/icons/Assignment";
import GroupIcon from "@material-ui/icons/Group";
import DateRangeIcon from "@material-ui/icons/DateRange";
import RedeemIcon from "@material-ui/icons/Redeem";
import KitchenIcon from "@material-ui/icons/Kitchen";
import { Loyalty } from "@mui/icons-material";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import PaidIcon from "@mui/icons-material/Paid";
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme
} from "@material-ui/core/styles";
import { permissions } from "./constants";
import {
  RequireCampaignAccess,
  RequireProductCampaignAccess
} from "./Authorized";
import { Box, Collapse } from "@material-ui/core";
import {
  AccountBalance,
  AttachMoney,
  Delete,
  ExpandLess,
  ExpandMore,
  PieChartOutlined,
  RecordVoiceOver
} from "@material-ui/icons";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import { Dashboard } from "./views/dashboard";
import { Reports } from "./views/reports";
import { Marketing } from "./views/marketing";
import { Discounts } from "./views/discounts";
import { UserContext } from "./UserProvider";
import { Chart } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "./store";
import { Authenticated, hasRole, UserLocation } from "./models/User";
import { StoreList } from "./views/stores/StoreList";
import { UserOrderOverview } from "./views/stores/UserOrderOverview";
import { UserOrders } from "./views/stores/UserOrders";
import { StoreOrderOverview } from "./views/stores/StoreOrderOverview";
import { StoreOrders } from "./views/stores/StoreOrders";
import { AwaitingStoreStocktaking } from "./views/stocktaking/AwaitingStoreStocktaking";
import { TenantList } from "./views/tenants";
import { TenantProducts } from "./views/tenants/Products";
import { StocktakingOverview } from "./views/stocktaking/StocktakingOverview";
import { ProductDelivery2 } from "./views/stores/ProductDelivery";
import { SalesStatistics } from "./views/statistics/sales/SalesStatistics";
import { OnShelfAvailabilityStatistics } from "./views/statistics/onshelf/OnShelfAvailabilityStatistics";
import { ProfitStatistics } from "./views/statistics/profit/ProfitStatistics";
import { CampaignStatistics } from "./views/statistics/campaign/CampaignStatistics";
import { CustomerFeedbackStatistics } from "./views/statistics/feedback/CustomerFeedbackStatistics";
import { WasteStatistics } from "./views/statistics/waste/WasteStatistics";
import { SegmentOverview } from "./views/segments/SegmentOverview";
import { CampaignList } from "./views/campaigns/CampaignList";
import { UserList } from "./views/users/UserList";
import { RegisterPurchase } from "./views/users/purchases/RegisterPurchase";
import { TranslationsList } from "./views/translations/TranslationList";
import { MarketList } from "./views/markets";
import { grey } from "@material-ui/core/colors";
import Tooltip from "@material-ui/core/Tooltip";
import { UserMenu } from "./views/toolbar/usersettings/UserMenu";
import { MyStoreMenu } from "./views/toolbar/mystore/MyStoreMenu";
import { EditDiscount } from "./views/discounts/components/EditDiscount";
import { CreateDiscount } from "./views/discounts/components/CreateDiscount";
import { AgeVerification } from "./views/toolbar/AgeVerification";
import { TenantMenu } from "./views/toolbar/tenants/TenantMenu";
import { PersonnelList } from "./views/personnel/PersonnelList";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  FeatureType,
  hidesProductCampaigns,
  TenantTypeName
} from "./models/Tenant";
import { Payouts } from "./views/statistics/payouts/Payouts";
import useStyles from "./styles";
import { StoreEvents } from "./views/stores/StoreList/components/StoreEvents";
import MobilePOSReceipts from "./views/mobilePOS/MobilePOSReceipts";
import MobilePOSCashierReports from "./views/mobilePOS/MobilePOSCashierReports";
const drawerWidth = 280;

const publicStatisticsRoutes = (
  <>
    <Route path="/statistics/sales" element={<SalesStatistics />} />
    <Route
      path="/statistics/onshelfavailability"
      element={<OnShelfAvailabilityStatistics />}
    />
    <Route path="/statistics/profit" element={<ProfitStatistics />} />
    <Route path="/statistics/waste" element={<WasteStatistics />} />
    <Route path="/statistics/payouts" element={<Payouts />} />
  </>
);

const sharedRoutes = (
  <>
    {publicStatisticsRoutes}
    <Route path="/statistics/campaign" element={<CampaignStatistics />} />
    <Route
      path="/statistics/feedback"
      element={<CustomerFeedbackStatistics />}
    />
    <Route path="/users" element={<UserList />} />
    <Route
      path="/users/:customerId/purchases/register"
      element={<RegisterPurchase />}
    />
    <Route path="/users/:userId" element={<UserList />} />

    <Route path="/segments" element={<SegmentOverview />} />
    <Route path="/reports" element={<Reports />} />
    <Route path="/marketing" element={<Marketing />} />
  </>
);

const tenantRoutes = {
  [TenantTypeName.StoreKey]: (
    <>
      {sharedRoutes}
      <Route
        path="/stores/:storeId/user-orders/:userOrderId"
        element={<UserOrderOverview />}
      />
      <Route path="/stores/:storeId/user-orders" element={<UserOrders />} />
      <Route
        path="/stores/any/orders/:storeOrderId"
        element={<StoreOrderOverview />}
      />
      <Route path="/stores/:storeId/orders" element={<StoreOrders />} />
      <Route
        path="/stores/:storeId/awaiting-stock-taking"
        element={<AwaitingStoreStocktaking />}
      />
      <Route path="/stores/:storeId/:tab" element={<StoreList />} />

      <Route path="/stock-taking/overview" element={<StocktakingOverview />} />

      <Route path="/products/delivery" element={<ProductDelivery2 />} />
      <Route path="/sales-and-visitors" element={<StoreEvents />} />
    </>
  ),
  [TenantTypeName.WhiteLabel]: (
    <>
      {sharedRoutes}
      <Route path="/sales-and-visitors" element={<StoreEvents />} />
    </>
  ),
  [TenantTypeName.MobilePOS]: (
    <>
      {sharedRoutes}
      <Route path="/receipts" element={<MobilePOSReceipts />} />
      <Route path="/cashier-reports" element={<MobilePOSCashierReports />} />
    </>
  )
};

const commonRoutes = (
  <>
    <Route path="/" element={<Dashboard />}>
      <Route path="age-verifications" element={<AgeVerification />}>
        <Route path=":ageVerificationId" element={<AgeVerification />} />
      </Route>
    </Route>
    <Route path="/stores" element={<StoreList />}>
      <Route path=":storeId" />
    </Route>
    <Route path="/tenants" element={<TenantList />}>
      <Route path=":tenantId" />
    </Route>
    <Route
      path="/tenant-products"
      element={
        <RequireProductCampaignAccess allow={permissions.products}>
          <TenantProducts />
        </RequireProductCampaignAccess>
      }
    >
      <Route path=":productId" />
    </Route>

    <Route
      path="/campaigns"
      element={
        <RequireCampaignAccess allow={permissions.stores}>
          <CampaignList />
        </RequireCampaignAccess>
      }
    >
      <Route path=":campaignId" />
    </Route>
    <Route path="/discounts" element={<Discounts />}>
      <Route path=":discountId" element={<EditDiscount />} />
      <Route path="new" element={<CreateDiscount />} />
    </Route>
    <Route path="/markets" element={<MarketList />} />
    <Route path="/personnel" element={<PersonnelList />} />
    <Route path="/personnel/:personId" element={<PersonnelList />} />
    <Route path="/translations" element={<TranslationsList />} />
  </>
);

const MainContent = ({ queryClient }: { queryClient: any }) => {
  const user = useContext(UserContext) as Authenticated;
  const classes = useStyles();
  const location = useLocation();
  const locationState = location.state as any;
  const background = locationState && locationState?.background;

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <QueryClientProvider client={queryClient}>
        <Routes location={background || location}>
          {hasRole(user, ["DistributorManager"]) ? (
            hidesProductCampaigns(user.tenant.tenantType.name) ? (
              <>
                {publicStatisticsRoutes}
                <Route
                  path="*"
                  element={<Navigate replace to="/statistics/sales" />}
                />
              </>
            ) : (
              <>
                <Route
                  path="/tenant-products"
                  element={
                    <RequireProductCampaignAccess allow={permissions.products}>
                      <TenantProducts />
                    </RequireProductCampaignAccess>
                  }
                >
                  <Route path=":productId" />
                </Route>
                {publicStatisticsRoutes}
                <Route
                  path="*"
                  element={<Navigate replace to="/tenant-products" />}
                />
              </>
            )
          ) : (
            <>
              <Route path="*" element={<Navigate replace to="/" />} />
              {commonRoutes}
              {tenantRoutes[user.tenant.tenantType.name]}
            </>
          )}
        </Routes>
      </QueryClientProvider>
      {!hasRole(user, ["DistributorManager"]) && background && (
        <Routes>
          <Route path="age-verifications" element={<AgeVerification />}>
            <Route path=":ageVerificationId" element={<AgeVerification />} />
          </Route>
        </Routes>
      )}
    </main>
  );
};

export default MainContent;
